import { LEGACY_AREA_COLORS, PRIMARY_COLORS, SECONDARY_COLORS } from '../design-system/colors';

/**
 * SVG icon constants
 */
export const LOCK_ICON_SVG = '<svg class="w-4 h-4 inline-block ml-1" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clip-rule="evenodd"></path></svg>';

export const MOBILE_ICON_SVG = '<svg class="w-4 h-4 inline-block" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"></path></svg>';

export const DESKTOP_ICON_SVG = '<svg class="w-4 h-4 inline-block" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path></svg>';

/**
 * Area badge CSS classes
 */
export const AREA_BADGES: Record<string, string> = {
  visual: 'area-visual',
  copy: 'area-copy',
  performance: 'area-performance',
  seo: 'area-seo',
  accessibility: 'area-accessibility'
};

/**
 * Area badge colors (from design system)
 */
export const AREA_BADGE_COLORS = LEGACY_AREA_COLORS;

/**
 * Page type display names
 */
export const PAGE_NAMES: Record<string, string> = {
  product: 'Product Page',
  collection: 'Collection Page',
  home: 'Home Page',
  cart: 'Cart Page'
};

/**
 * Device filter display names
 */
export const DEVICE_FILTER_NAMES: Record<string, string> = {
  all: 'All Devices',
  mobile: 'Mobile Only',
  desktop: 'Desktop Only'
};

/**
 * Categories for empty state checks (secondary filters)
 */
export const CATEGORIES = ['visual', 'copy', 'performance', 'seo', 'accessibility'] as const;

/**
 * Primary category display names
 */
export const PRIMARY_CATEGORY_NAMES: Record<string, string> = {
  'cro-ux': 'CRO + UX Clarity',
  'technical': 'Technical Health'
};

/**
 * Primary category colors (from design system)
 */
export const PRIMARY_CATEGORY_COLORS = PRIMARY_COLORS;

/**
 * Secondary category colors (from design system)
 */
export const SECONDARY_CATEGORY_COLORS = SECONDARY_COLORS;

/**
 * Effort level labels
 */
export const EFFORT_LABELS = ['Very Easy', 'Easy', 'Medium', 'Hard', 'Very Hard'] as const;
